var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7998 5.99999L6.6998 9.89999C6.88314 10.0833 6.9748 10.3167 6.9748 10.6C6.9748 10.8833 6.88314 11.1167 6.6998 11.3C6.51647 11.4833 6.28314 11.575 5.9998 11.575C5.71647 11.575 5.48314 11.4833 5.2998 11.3L0.699805 6.69999C0.599805 6.59999 0.528971 6.49165 0.487305 6.37499C0.445638 6.25832 0.424805 6.13332 0.424805 5.99999C0.424805 5.86665 0.445638 5.74165 0.487305 5.62499C0.528971 5.50832 0.599805 5.39999 0.699805 5.29999L5.2998 0.699988C5.48314 0.516654 5.71647 0.424988 5.9998 0.424988C6.28314 0.424988 6.51647 0.516654 6.6998 0.699988C6.88314 0.883321 6.9748 1.11665 6.9748 1.39999C6.9748 1.68332 6.88314 1.91665 6.6998 2.09999L2.7998 5.99999Z",
    fill: "#080E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.5fe149affd1c4230b4684c7fcd8d4f31.svg";
export { ForwardRef as ReactComponent };